import type { WF_RecentlyUsedWorkflow } from './WF.RecentlyUsedWorkflow'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { compact, map, uniqWith, slice } from '../../../shared/lib/functional/array.no-deps'
import { IDB_doneReports } from '../IDB/IDB.dexie'
import type { Proc_Procedure } from '../Proc/Proc.Procedure'
import { findById } from '../../../shared/lib/functional/identifiable.no-deps'

export async function WF_getRecentlyUsedWorkflows(procedures: Proc_Procedure[]): Promise<WF_RecentlyUsedWorkflow[]> {
    const doneReports = await IDB_doneReports().orderBy('startDate').reverse().toArray()

    return pipe(
        doneReports,
        map((doneReport) => {
            const procedure = findById(procedures, doneReport.procedure)
            if (procedure == null) return null

            const workflow = findById(procedure.workflows, doneReport.workflow)
            if (workflow == null) return null

            return {
                procedureId: procedure.id,
                procedureName: procedure.name,
                workflowId: workflow.id,
                workflowName: workflow.name,
                workflowType: workflow.type,
            }
        }),
        compact,
        uniqWith((a, b) => a.procedureId === b.procedureId && a.workflowId === b.workflowId),
        slice(0, 3)
    )
}
